module.exports = {
  // APIURl: "http://192.168.36.69:9099" //测试
  // APIURl: "http://192.168.36.215:9099"   //赵芳刚
  // APIURl: " http://192.168.36.221:9081" //贺家文
  APIURl: `${window.location.protocol}//${window.location.host}/api`
}
